<template>
  <div class="bo">
    <div class="container">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-dynamic"
        size="mini"
      >
        <el-form-item
          :label="$t('person.baseInfos.companyName')"
          prop="company"
        >
          <span>{{ ruleForm.company }}</span>
        </el-form-item>
        <el-form-item :label="$t('person.baseInfos.address')" prop="column17">
          <el-input v-model="ruleForm.column17"></el-input>
        </el-form-item>

        <el-form-item :label="$t('person.baseInfos.name')" prop="name">
          <div class="boxName">
            <span slot="label">{{ ruleForm.name }} </span>
            <div class="itemTxt" v-if="realName == 1">
              <img src="../../../static/menuIcon/实名认证状态.png" />
              <div class="adutext">{{$t('mobile.authentication')}}</div>
            </div>
          </div>
        </el-form-item>

        <el-form-item :label="$t('person.baseInfos.named')" prop="named">
          <el-radio v-model="radio" :label="$t('person.baseInfos.named1')">{{
            $t("person.baseInfos.named1")
          }}</el-radio>
          <el-radio v-model="radio" :label="$t('person.baseInfos.named2')">{{
            $t("person.baseInfos.named2")
          }}</el-radio>
        </el-form-item>
        <el-form-item :label="$t('person.baseInfos.type')" prop="column16">
          <span>{{ ruleForm.column16 }}</span>
        </el-form-item>
        <el-form-item :label="$t('person.baseInfos.number')" prop="column15">
          <span>{{ ruleForm.column15 }}</span>
        </el-form-item>
        <el-form-item
          :label="$t('person.baseInfos.phone')"
          prop="registAccount"
        >
          <span>{{ ruleForm.registAccount }}</span>
        </el-form-item>
        <el-form-item :label="$t('person.baseInfos.email')" prop="email">
          <el-input v-model="ruleForm.email"></el-input>
          <div class="tips">{{ $t("person.baseInfos.tips.emailTip") }}</div>
        </el-form-item>
        <el-form-item :label="$t('person.baseInfos.dept')" prop="dept">
          <el-input v-model="ruleForm.dept"></el-input>
        </el-form-item>
        <el-form-item :label="$t('person.baseInfos.duty')" prop="duty">
          <el-input v-model="ruleForm.duty"></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { getInfo, saveInfo } from "../../../../api/personInfo.js";
import { auth } from "../../../../api/common.js";
export default {
  data() {
    return {
      ruleForm: {
        company: "", //公司名称
        column17: "", //单位的地址
        name: "", //姓名
        named: "", //称呼
        column16: "", // 证件类型
        column15: "", //	身份证号
        registAccount: "", //手机号
        email: "", //邮箱
        dept: "", //部门
        duty: "", //职位
      },
      rules: {
        // company: [{ required: true, message: '公司名称不能为空' }],
        // column17: [{ required: true, message: '单位地址不能为空' }], //单位的地址
        name: [{ required: false }], //姓名
        named: [{ required: false }], //称呼
        column16: [{ required: false }], // 证件类型
        column15: [
          { required: true, message: this.$t("person.baseInfos.rules.number") },
        ], //	身份证号
        registAccount: [
          { required: true, message: this.$t("common.rules.phone") },
        ], //手机号
        email: [{ required: true, message: this.$t("common.rules.email") }], //邮箱
      },
      radio: this.$t("person.baseInfos.named2"),
      realName: 0, //实名认证的状态
    };
  },

  methods: {
    // 获取个人信息函数
    async getPersonInfo() {
      try {
        const { data } = await getInfo();
        if (data.code === 200) {
          this.ruleForm = data.data;
          this.radio = data.data.named;
        }
      } catch (err) {
        console.log(err.message);
      }
    },
    async submitForm() {
      this.ruleForm.named = this.radio;
      try {
        const { data } = await saveInfo(this.ruleForm);
        if (data.code === 200) {
          this.getPersonInfo();
        }
      } catch (err) {
        console.log(err.message);
      }
    },
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.submitForm();
          this.$message({
            showClose: true,
            message: "保存成功！",
            type: "success",
          });
        } else {
          this.$message.error(this.$t("common.require"));
        }
      });
    },

    //判断是否是实名认证
    isAuth(arg) {
      const flag = arg;
      if (flag == "true") {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.getPersonInfo();
    this.realName = Number(localStorage.getItem("realName"));
  },
  watch: {
    realName(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$nextTick(() => {
          this.realName = newVal;
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  margin: 0 auto;
  margin-top: 10px;
  .tips {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
    margin: 5px 0px;
  }
}
.box12 {
  width: 100%;
}
.saveBtn {
  width: 320px;
  height: 36px;
  background: #006fb8;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  letter-spacing: 2px;
  border: none;
  border-radius: 4px;
}
.boxName {
  position: relative;
  .itemTxt {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    right: 0px;
    top: 0px;
    height: 26px;
    img {
      width: 20px;
      height: 20px;
    }
    .adutext {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #2cd329;
      line-height: 17px;
      padding-left: 5px;
      box-sizing: border-box;
    }
  }
}
</style>
<style scoped>
.bo {
  padding-bottom: 20px !important;
}
.el-input >>> .el-input__inner {
  width: 272px;
  display: block;
}
.el-form {
  margin-top: 25px;
}
.el-button {
  width: 88px;
  height: 32px;
  background: #006fb8;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.container >>> .el-form-item__label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  line-height: 20px;
  color: #606266 !important;
}
.container >>> .el-form-item__label {
  float: none;
  word-break: break-word;
}
.container >>> .el-form-item {
  margin-bottom: 10px !important;
}
.container >>> .el-form-item__content {
  margin: 5px 0px;
}
.bo >>> .el-card {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  border: none !important;
  border: 1px solid transparent !important;
  border-radius: 0px !important;
}
</style>
